import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=21394684&scoped=true&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=21394684&lang=scss&"
import style1 from "./TemplateView.vue?vue&type=style&index=1&id=21394684&lang=scss&scoped=true&"
import style2 from "./TemplateView.vue?vue&type=style&index=2&id=21394684&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21394684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21394684')) {
      api.createRecord('21394684', component.options)
    } else {
      api.reload('21394684', component.options)
    }
    module.hot.accept("./TemplateView.vue?vue&type=template&id=21394684&scoped=true&", function () {
      api.rerender('21394684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/add/TemplateView.vue"
export default component.exports